<template>
<div class="w100">
    <b-row>
         <b-col cols="3" class="text-left">
             <!-- Mode -->
            <p class="mr-10 lh-30 mb-0">{{ $t("messages.mode") }}:</p>
         </b-col>
          <b-col cols="9" class="text-left">
            <b-button-group id="mode" class="menuOpt">
                <!-- MANUAL AUTO -->
                <b-button class="optInt" style="margin:0px;" @click="lightingInfo.light.mode = 0" :pressed="lightingInfo.light.mode === 0">{{ $t("messages.manual") }}</b-button>
                <b-button class="optInt" style="margin:0px;" @click="lightingInfo.light.mode = 1" :pressed="lightingInfo.light.mode === 1">{{ $t("messages.auto") }}</b-button>
            </b-button-group>
          </b-col>
    </b-row>
    <b-row v-if="lightingInfo.light.mode===1" class="mtop10">
        <b-col cols="3" class="fspecial mb-0 text-right">
            <p class="mr-10 lh-30 mb-0">{{ $t("messages.interval") }}:</p>
        </b-col>
        <b-col cols="3" class="text-left">
            <el-time-picker v-model="timer1" format="HH:mm" value-format="HH:mm" :clearable=false></el-time-picker>
        </b-col>
        <div class="text-center" style="padding:0;width:10px !important;display:inline-block;">
            <p style="line-height:35px;margin-bottom:0;">-</p>
        </div>
        <b-col cols="3" class="text-left">
            <el-time-picker  v-model="timer1To" format="HH:mm" value-format="HH:mm" :clearable=false></el-time-picker>
        </b-col>
    </b-row>
    <b-row v-if="lightingInfo.light.mode===1" class="mtop10">
        <b-col cols="3" class="text-left">
        <p class="mr-10 lh-30 mb-0">{{ $t("messages.frequency") }}:</p>
        </b-col>
        <b-col cols="9">
            <!-- Select -->
        <el-select v-model="lightingInfo.light.freq" :placeholder='$t("messages.select")' >
            <el-option v-for="item in getFreqs" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
        </el-select>
        </b-col>
    </b-row>
    <b-row v-if="lightingInfo.light.mode === 0"  class="mtop10">
        <b-col cols="3" class="text-left">
            <!-- State -->
            <p class="mr-10 lh-30 mb-0">{{ $t("messages.state") }}:</p>
        </b-col>
        <b-col cols="9" class="text-left">
            <b-button-group id="mode" class="menuOpt">
                <!-- OFF ON -->
                <b-button class="optInt" style="margin:0px;" @click="lightingInfo.light.status = 0 " :pressed="lightingInfo.light.status === 0">{{ $t("messages.off") }}</b-button>
                <b-button class="optInt" style="margin:0px;" @click="lightingInfo.light.status = 1" :pressed="lightingInfo.light.status === 1">{{ $t("messages.on") }}</b-button>
            </b-button-group>
        </b-col>
    </b-row>

    <b-row v-if="lightingInfo.main.hasLED===1" class="mtop10">
          <span class="divider"></span>
        <b-col cols="3" class="fspecial mb-0 text-left">
            <p class="mr-10 lh-30 mb-0">{{ $t("messages.ledColor") }}:</p>
        </b-col>
      
        <b-col cols="9" class="text-left">
             <img src="@/assets/icono-colores.svg" style="height:30px">
                 <b-button-group id="mode" class="menuOpt">
                    <b-button class="optInt" style="margin-left:10px;" @click="changeLedColor('change')">{{ $t("messages.next") }}</b-button>
                </b-button-group>
        </b-col>
        
    </b-row>
    <actions :has-changes="hasChanges" v-on:onSave="onSave" v-on:onCancel="onCancel"></actions>
</div>


</template>

<script>
import Actions from "./utils/Actions";

export default {
    name: 'Lighting',
    components:{
        Actions
    },
    props: {
        poolId: Object
    },

    created() {
        this.$parent.$on('update', this.setValue);
    },
    mounted() {
        let fresh = JSON.parse(JSON.stringify(this.poolId));
        this.lightingInfo = fresh
        this.original = JSON.parse(JSON.stringify(fresh));
        
    },
    data() {
        return {
            hasChanges: false,
            original: null, 
            showCloseBtn: false,
            lightingInfo: {
                'main':{
                    'hasLED': 0
                },
                'light':{
                    'mode': 0,
                    'status': 0,
       
                }
            }
        }
    },

    computed: {
        getFreqs(){
            return  [
                {
                    value: 86400,
                    label: this.$t("messages.daily")
                },
                {
                    value: 172800,
                    label: this.$t("messages.2daily")
                },
                {
                    value: 259200,
                    label: this.$t("messages.3daily")
                },
                {
                    value: 345600,
                    label: this.$t("messages.4daily")
                },
                {
                    value: 432000,
                    label: this.$t("messages.5daily")
                },
                {
                    value: 604800,
                    label: this.$t("messages.weekly")
                },
                {
                    value: 1209600,
                    label: this.$t("messages.2weekly")
                },
                {
                    value: 1814400,
                    label: this.$t("messages.3weekly")
                },
                {
                    value: 2419200,
                    label: this.$t("messages.4weekly")
                }
            ]
        },
        timer1:{
            get(){
                return this.$moment.unix(this.lightingInfo.light.from).utc().format("HH:mm")
            },
            set(newDate) { 
                this.lightingInfo.light.from = this.$moment.duration(newDate).asSeconds()+1
            }
        },
        timer1To:{
            get(){
               return this.$moment.unix(this.lightingInfo.light.to).utc().format("HH:mm")
            },
            set(newDate) { 
                this.lightingInfo.light.to = this.$moment.duration(newDate).asSeconds()+1
            }
        },
    },
    watch: {
        'lightingInfo': {
            handler(value) {
                this.hasChanges = (JSON.stringify(value) === JSON.stringify(this.original)) ? false : true
            },
            deep: true
        }
    },

    methods:{
        onSave () {
            this.$emit('onSave',this.original, this.lightingInfo, 'light');
            this.original = JSON.parse(JSON.stringify(this.lightingInfo));
            this.hasChanges = false
        },
        onCancel() {
            this.lightingInfo = JSON.parse(JSON.stringify(this.original));
            this.hasChanges = false;
        },
        setValue: function(value) {
            console.log(value);
        },
     
        changeLedColor(type){
            this.showCloseBtn = (type == 'change') ? true : false;
            this.$snotify.async(this.$t("messages.alertConnectingPool"), this.$t("messages.alertSendingData"), () => new Promise((resolve, reject) => {
                this.$store.dispatch('changeColor', {
                    'wifi': this.lightingInfo.wifi,
                    'id': this.lightingInfo.id,
                    'type': type
                }).then(response => {
                   resolve({
                        title: 'Info',
                        body: this.$t("messages.configRecieved") ,
                        config: {
                            timeout: 1500,
                            closeOnClick: false
                        }
                    })
                }, error => {
                    console.log('error');
                    reject({
                        // the pool is not connected
                        title: 'Info',
                        body: this.$t("messages.poolNotConnected") ,
                        config: {
                            timeout: 3000,
                            closeOnClick: true
                        }
                    })
                });
            }))
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Lighting.vue